/* eslint import/prefer-default-export: 0 */
import {
  REQUEST,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
  LOGIN_PENDING,
  LOGIN_ERROR,
  SET_TOKEN,
  SET_TOKENS,
  LOGOUT,
  SET_BACK_URL,
  LOCK_REQUESTS,
  UNLOCK_REQUESTS,
  CLEAR_SESSION,
} from "../actions/types"

export const INITIAL_STATE = {
  /* Token type */
  tokenType: undefined,
  /* Token */
  token: false,
  /* Refresh token */
  refreshToken: false,
  /* Token expires in */
  expiresIn: 0,
  /* User info (doesn't implement yet) */
  user: {},
  /* For use application as a service */
  backUrl: undefined,
  /* ??? */
  hasError: false,
  /* ??? */
  isLoading: false,
  /* All requests are locked for now */
  requestsLocked: false,
  /* All requests performed right now */
  requests: [],
}

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        requests: state.requests.concat([action]),
      }
    case REQUEST_SUCCESS:
    case REQUEST_ERROR:
      return {
        ...state,
        requests: state.requests.filter(action => action === action.action),
      }
    case LOGIN_PENDING:
      return {
        ...state,
        isLoading: true,
      }

    case LOGIN_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        token: ``,
        errorText: action.error || `Ошибка связи с сервером`,
      }

    case SET_TOKEN: {
      return {
        ...state,
        token: action.token,
      }
    }

    case SET_TOKENS: {
      return {
        ...state,
        token: action.token,
        refreshToken: action.refreshToken,
        tokenType: action.tokenType,
        expiresIn: action.expiresIn,
      }
    }

    case CLEAR_SESSION:
      return INITIAL_STATE

    case LOGOUT:
      return INITIAL_STATE

    case SET_BACK_URL:
      return {
        ...state,
        backUrl: action.url,
      }
    case LOCK_REQUESTS:
      return {
        ...state,
        requestsLocked: true,
      }
    case UNLOCK_REQUESTS:
      return {
        ...state,
        requestsLocked: false,
      }
    default:
      return state
  }
}
